<template>
  <v-container class="section">
    <!-- Grid -->
    <v-row>
      <!-- Left column -->
      <v-col cols="12" md="6">
        <div class="pt-16">
          <!-- The megaphone image -->
          <v-img
            contain
            width="328"
            height="115"
            class="mt-6"
            src="/img/svg/megaphone.svg"
            v-vue-aos.once="{ animationClass:'fadeIn animated' }"
          />

          <!-- Text -->
          <div
            class="section__text mt-6"
            v-vue-aos.once="{ animationClass:'fadeIn slow animated' }"
          >
            <div class="primary--text text-h3 font-weight-bold">
              Influencer
            </div>

            <div class="bluegray--text font-weight-bold section__text__large">
              Marketing
            </div>

            <div class="bluegray--text text-h5 font-weight-bold">
              Done right!
            </div>
          </div>
        </div>
      </v-col>

      <!-- Right column -->
      <v-col
        cols="12"
        md="6"
        class="d-flex justify-end"
      >
        <div>
          <!-- The under-lapping image -->
          <div class="d-flex justify-end">
            <v-img
              v-prlx
              contain
              width="278"
              height="278"
              max-width="278"
              src="/img/svg/social-media-analysis.svg"
            />
          </div>

          <!-- Overlapping text section -->
          <div class="text-right relative">
            <!-- The over-text -->
            <div class="bluegray--text font-weight-bold">
              Over
            </div>

            <!-- The leading text -->
            <div class="primary--text text-h3 font-weight-bold">
              <vue-number
                ref="numberAnimation"
                :from="100"
                :to="244"
                :duration="2"
                :animationPaused="isPaused"
              />
              Million+
            </div>

            <!-- The under-text -->
            <div class="bluegray--text font-weight-bold">
              Influencers Available Across
            </div>

            <!-- The social icons -->
            <div class="d-flex justify-end">
              <v-img
                contain
                max-width="240"
                src="/img/png/social-icons.png"
              />
            </div>
          </div>
        </div>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
// Import child component
import VueNumber from 'vue-number-animation/Number.vue'

// Export the SFC
export default {
  // Name of the component
  name: "Introduction",

  // Register the children
  components: {
    VueNumber
  },

  // Define local variables
  data: () => ({
    isPaused: true
  }),

  // Define method functions
  methods: {
    /**
     * When called, plays the animation counter
     *
     * @returns {void}
     */
    playAnimation() {
      this.isPaused = false
      this.$refs.numberAnimation.play()
    },

    /**
     * Handle the scroll event to check if we should show the counter animation
     *
     * @returns {void}
     */
    handleScroll() {
      // If we've already played the animation don't continue
      if (this.isPaused === false) return

      const rect = this.$refs.numberAnimation.$el.getBoundingClientRect()
      const condition = (
        rect.top >= 0 &&
        rect.left >= 0 &&
        rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
        rect.right <= (window.innerWidth || document.documentElement.clientWidth)
      )

      // If the condition is true, play it
      if (condition) {
        this.playAnimation()
      }
    }
  },

  /**
   * As soon as the component is created
   *
   * @returns {void}
   */
  created() {
    window.addEventListener("scroll", this.handleScroll)
  },

  /**
   * Right before the component is destroyed from the view
   *
   * @returns {void}
   */
  beforeDestroy() {
    window.removeEventListener("scroll", this.handleScroll)
  }
}
</script>

<style lang="stylus" scoped>
.section
  &__text
    &__large
      font-size 4em
      line-height 1.1

  .relative
    position relative
    top -5em
</style>
